import * as api from "../../redux/api/actions.js";

import React, { Component } from "react";

import Container from "@material-ui/core/Container";
import MainContainer from "../../components/MainContainer";
import PreRegisterUserForm from "./components/PreRegisterUserForm.js";
import Prompt from "../../components/Prompt";
import TitleBar from "../../components/TitleBar";
import TopBar from "../../components/TopBar";
import CustomSwitch from "../../components/CustomSwitch.js";
import UserForm from "./components/UserForm.js";
import _ from "lodash";
import { connect } from "react-redux";
import { getLoggedUser } from "../../redux/auth/actions";
import { AVAILABLE_ENTITIES, utils } from "../../database";
import { withRouter } from "react-router-dom";

class PreRegisterUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      text: "",
      loggedUser: null,
      checked: false,
    };

    this.onCancel = this.onCancel.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  async componentDidMount() {
    this.props.getAvailableRoles();

    console.log("🔍 PreRegisterUser - componentDidMount:");
    console.log("  - this.props.user:", this.props.user);
    console.log("  - this.props.user?.zoetisId:", this.props.user?.zoetisId);

    // Buscar dados do usuário logado
    try {
      const loggedUser = await getLoggedUser();
      if (loggedUser && loggedUser.userId) {
        this.setState({ loggedUser });
      }
    } catch (error) {
      console.error("Erro ao buscar usuário logado:", error);
    }
  }

  onCancel() {
    console.log("🔄 PreRegisterUser - onCancel called, redirecting to /users");
    this.props.history.push("/users");
  }

  async onSubmit(payload) {
    const loggedUser = this.state.loggedUser || this.props.logged;

    if (!loggedUser || !loggedUser.userId) {
      this.setState({
        hasError: true,
        text: "Não foi possível identificar o usuário logado. Por favor, tente fazer login novamente.",
      });
      return;
    }

    // Se está criando usuário sem e-mail, usa o endpoint diferente
    if (this.state.checked) {
      await this.props.createWithoutEmail(payload).then((result) => {
        if (!result?.hasErrors) {
          alert("Usuário criado com sucesso!");
          this.props.history.push("/users");
        } else {
          this.setState({
            hasError: true,
            text: result.title,
          });
        }
      });
    } else {
      const newPayload = {
        ...payload,
        superiorId: loggedUser.userId,
        rolesIds: [payload.role],
      };
      await this.props.create(newPayload).then((result) => {
        if (!result?.hasErrors) {
          alert("Pré-cadastro de usuário criado com sucesso!");
          this.props.history.push("/users");
        } else {
          this.setState({
            hasError: true,
            text: result.title,
          });
        }
      });
    }
  }

  render() {
    return (
      <Container>
        <TopBar title="" />
        <TitleBar
          title="Convidar Novo Usuário"
          buttons={[
            {
              onClick: () => {
                console.log(
                  "🔄 PreRegisterUser - Voltar button clicked, redirecting to /users",
                );
                this.props.history.push("/users");
              },
              label: `Voltar`,
            },
          ]}
          paths={[
            {
              route: "/users",
              label: "Usuários",
            },
            {
              label: "Convidar Novo Usuário",
            },
          ]}
        />
        <MainContainer>
          <div className="grid">
            <div className="p-12 p-display-flex p-justify-space-between grid-item">
              <div />
              <CustomSwitch
                fontSize={"16px"}
                onHandleChange={(event) =>
                  this.setState({ checked: event.target.checked })
                }
                checked={this.state.checked}
                text="Criar um usuário sem e-mail"
              />
            </div>
          </div>
          {this.state.checked ? (
            <UserForm
              onCancel={this.onCancel}
              onSubmit={this.onSubmit}
              roles={this.props.availableRoles}
              user={null}
            />
          ) : (
            <PreRegisterUserForm
              onCancel={this.onCancel}
              onSubmit={this.onSubmit}
              dispatch={this.props.dispatch}
              roles={this.props.availableRoles}
              initialValues={{ zoetisId: this.props.user?.zoetisId }}
            />
          )}
        </MainContainer>
        <Prompt
          visible={this.state.hasError}
          title="Erro ao inserir usuário"
          message={this.state.text}
          buttons={[
            {
              label: "Ok",
              onClick: () => this.setState({ hasError: false }),
            },
          ]}
        />
      </Container>
    );
  }
}

const propsFromDatabase = async (props) => {
  const loggedUser = await getLoggedUser();
  const user = await utils.getElement(
    AVAILABLE_ENTITIES.USERS,
    loggedUser.userId,
  );

  console.log("🔍 PreRegisterUser - propsFromDatabase:");
  console.log("  - loggedUser:", loggedUser);
  console.log("  - user:", user);
  console.log("  - user.zoetisId:", user?.zoetisId);

  return {
    user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    create: async (params) =>
      api.post(dispatch, "users", `Account/PreRegister`, params),
    createWithoutEmail: async (params) =>
      api.post(dispatch, "users", `Account`, params),
    getAvailableRoles: () => api.get(dispatch, "users", `Profile/`),
  };
};

const mapStateToProps = (state) => ({
  loading: api.getApiLoading(state, `Account/PreRegister`),
  error: api.getApiError(state, `Account/PreRegister`),
  success: api.getApiResult(state, `Account/PreRegister`),
  availableRoles: api.getApiResult(state, `Profile/`) || [],
  logged: state.auth.logged,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(utils.withPropsFromDatabase(propsFromDatabase, withRouter(PreRegisterUser)));
